/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable import/no-unresolved */
import {
    AccordionItem, AccordionItemBody, AccordionItemHeader, Accordions, Breadcrumb, Button, Panel, Table, Tabs, Tab,
} from 'appkit-react';
import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

import Metro2AuditLog from '../containers/Metro2AuditLog';
import '../styles/metro2.scss';
import Metro2Comments from '../containers/Metro2Comments';
import Metro2ClassifyResult from './Metro2ClassifyResult';

const Metro2Results = ({
    breadcrumbItems, onNavigate, columns, criteria, fetchData, data, pages, pagesize, setPageSize, setPageNumber, auditLog, refetch, pageSizeOptions,
}) => {
    const history = useHistory();
    const [showClassifyResult, setShowClassifyResult] = useState(false);

    return (
        <>
            <div className="true-comply-metro2-results_layout">
                <div className="true-comply-metro2-results_column-2">
                    <Breadcrumb items={breadcrumbItems} />
                    <Row>
                        <Col md={4}>
                            <div className="a-h2 title-label">
                                <span className="appkiticon icon-left-chevron-outline left-arrow-icon" onClick={() => history.goBack()} role="presentation" />
                                {`Rule #${(criteria && criteria.ruleId) ? criteria.ruleId : ''} Results`}
                            </div>
                        </Col>
                        <Col className="classyfy_btn_container">
                            <Row>
                                <Col style={{ textAlign: 'right' }}>
                                    <span>
                                        <Button size="lg" style={{ marginLeft: '1rem' }} onClick={() => setShowClassifyResult(true)}>
                                            CLASSIFY RESULTS
                                        </Button>
                                        {showClassifyResult
                                            && (
                                                <Metro2ClassifyResult
                                                    setShowClassifyResult={setShowClassifyResult}
                                                    refetch={auditLog.refetch}
                                                    refetchTestData={refetch}
                                                />
                                            )}
                                    </span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    <Accordions className="true-comply-metro2-accordion" activeItem={['panel-1', 'panel-2']}>
                        <AccordionItem itemId="panel-1" size="lg">
                            <AccordionItemHeader className="background-white header" title="DIAGNOSTIC CRITERIA" />
                            <AccordionItemBody className="background-white" size="lg">
                                <hr style={{ marginTop: 0 }} />
                                <Row>
                                    <Col md={6}>
                                        <Row>
                                            <Col md={3} className="a-h6">
                                                Rule ID
                                                <span className="label">: </span>
                                            </Col>
                                            <Col md={8}>
                                                {criteria && criteria.ruleId}
                                            </Col>
                                        </Row>
                                        <Row className="row-margin">
                                            <Col md={3} className="a-h6">
                                                Field ID
                                                <span className="label">: </span>
                                            </Col>
                                            <Col md={8}>
                                                {criteria && criteria.fieldId}
                                            </Col>
                                        </Row>
                                        <Row className="row-margin">
                                            <Col md={3} className="a-h6">
                                                Field Name
                                                <span className="label">: </span>
                                            </Col>
                                            <Col md={8}>
                                                {criteria && criteria.fieldName}
                                            </Col>
                                        </Row>
                                        <Row className="row-margin">
                                            <Col md={3} className="a-h6">
                                                Field Number
                                                <span className="label">: </span>
                                            </Col>
                                            <Col md={8}>
                                                {criteria && criteria.fieldNumber}
                                            </Col>
                                        </Row>
                                        <Row className="row-margin">
                                            <Col md={3} className="a-h6">
                                                Is Active
                                                <span className="label">: </span>
                                            </Col>
                                            <Col md={8}>
                                                {criteria && criteria.isActive}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6}>
                                        <Row className="row-margin">
                                            <Col md={3} className="a-h6">
                                                Position
                                                <span className="label">: </span>
                                            </Col>
                                            <Col md={8}>
                                                {criteria && criteria.position}
                                            </Col>
                                        </Row>
                                        <Row className="row-margin">
                                            <Col md={3} className="a-h6">
                                                Recording
                                                <span className="label">: </span>
                                            </Col>
                                            <Col md={8}>
                                                {criteria && criteria.recording}
                                            </Col>
                                        </Row>
                                        <Row className="row-margin">
                                            <Col md={3} className="a-h6">
                                                Rule Type Serial
                                                <span className="label">: </span>
                                            </Col>
                                            <Col md={8}>
                                                {criteria && criteria.ruleTypeSerial}
                                            </Col>
                                        </Row>
                                        <Row className="row-margin" style={{ paddingBottom: '1.5rem', wordWrap: 'break-word' }}>
                                            <Col md={3} className="a-h6">
                                                Rule Description
                                                <span className="label">: </span>
                                            </Col>
                                            <Col md={8}>
                                                {criteria && criteria.ruleDescription}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </AccordionItemBody>
                        </AccordionItem>
                        <AccordionItem
                            itemId="panel-2"
                            style={{ marginTop: '1rem' }}
                        >
                            <AccordionItemHeader className="background-white header" title="RESULTS" />
                            <AccordionItemBody className="background-white">
                                <hr style={{ marginTop: 0 }} />
                                <Row>
                                    <Col md={6}>
                                        {data.length > 0 && (
                                            <Row>
                                                <Col md={3} className="a-h6">
                                                    Run Date
                                                    <span className="label">: </span>
                                                </Col>
                                                <Col md={8}>
                                                    {data[0].testDate}
                                                </Col>
                                            </Row>
                                        )}
                                        {data.length > 0 && (
                                            <Row className="row-margin">
                                                <Col md={3} className="a-h6">
                                                    Test Failed
                                                    <span className="label">: </span>
                                                </Col>
                                                <Col md={8}>
                                                    {data[0].testFail}
                                                </Col>
                                            </Row>
                                        )}
                                    </Col>
                                    <Col md={6}>
                                        {data.length > 0 && (
                                            <Row>
                                                <Col md={3} className="a-h6">
                                                    Test Errored
                                                    <span className="label">: </span>
                                                </Col>
                                                <Col md={8}>
                                                    <div>
                                                        {data[0].testError}
                                                    </div>
                                                </Col>
                                            </Row>
                                        )}
                                        {data.length > 0 && (
                                            <Row className="row-margin">
                                                <Col md={3} className="a-h6">
                                                    Test Run Status
                                                    <span className="label">: </span>
                                                </Col>
                                                <Col md={8}>
                                                    {data[0].testRunStatus}
                                                </Col>
                                            </Row>
                                        )}
                                    </Col>
                                </Row>
                                <hr style={{ marginTop: 0 }} />
                                <div className="result-table-container">
                                    <Table
                                        columns={columns}
                                        manual
                                        data={data}
                                        pages={pages}
                                        onFetchData={fetchData}
                                        defaultPageSize={pagesize}
                                        onPageSizeChange={pageSize => setPageSize(pageSize)}
                                        onPageChange={pageIndex => setPageNumber(pageIndex + 1)}
                                        pageSizeOptions={pageSizeOptions}
                                        noDataText="No Failed Data ..!!!"
                                    />
                                </div>
                            </AccordionItemBody>
                        </AccordionItem>
                    </Accordions>

                    <Panel style={{ marginTop: '1rem', marginBottom: '2rem' }}>
                        <Tabs defaultValue="1" className="a-tab-item-padding-10" size="md">
                            <Tab value="1" label="COMMENTS">
                                <Metro2Comments refetch={auditLog.refetch} />
                            </Tab>
                            <Tab value="2" label="AUDIT LOG">
                                <Metro2AuditLog data={auditLog.data && auditLog.data.getAuditLogsForMetro2} />
                            </Tab>
                        </Tabs>
                    </Panel>
                </div>

            </div>
        </>
    );
};

export default Metro2Results;
